/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
import React, { useState, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import InputGrid from "screens/leads/components/InputGrid";
import { MdFilterList, MdOutlineFilterListOff } from "react-icons/md";
import { Badge, SwipeableDrawer as Swipeable, Tooltip } from "@mui/material";
import { format } from "date-fns";
import { usePropostasListarEtapas } from "services/api/Funil_Propostas/etapas-listar-get";
import { usePropostasFiltrosEtapas } from "services/api/Funil_Propostas/etapas-filtro-get";
import { usePropostasFiltrosSubEtapas } from "services/api/Funil_Propostas/subetapas-filtro-get";
import { useExportarKanban } from "services/api/Funil_Propostas/exportar-kanban";
import ModalExportarKanban from "screens/funilPropostas/components/ModalExportarKanban";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { obterNomeEtapaExibicao } from "utils/obterNomeEtapaExibicao";
import * as IconsSVG from "../../assets/iconsSVG";
import NavCommon from "../../components/@navHeader";
import * as S from "./styles";
import EtapaCard from "./components/EtapaCard";
import Filtro from "./components/Filtro";

interface Option {
  value: string;
  label: string;
  codigoSap?: string;
}

const tipoFiltroDataOptions: Option[] = [
  { value: "0", label: "Data criação" },
  { value: "1", label: "Data atualização" },
];

const toApiDate = (date: Date | null) => {
  if (!date) return undefined;
  return format(date, "yyyy-MM-dd");
};

const FunilPropostas = () => {
  const history = useHistory();
  const { usuarioVivaz } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const [showFilters, setShowFilters] = useState(false);
  const [selectedEtapa, setSelectedEtapa] = useState<Option | null>(null);
  const [selectedSubetapa, setSelectedSubetapa] = useState<Option[]>([]);
  const [selectedEmpreendimento, setSelectedEmpreendimento] = useState<
    Option[]
  >([]);
  const [selectedBloco, setSelectedBloco] = useState<Option | null>(null);
  const [selectedUnidade, setSelectedUnidade] = useState<Option | null>(null);
  const [selectedOrigens, setSelectedOrigens] = useState<Option[]>([]);
  const [selectedSuperintendente, setSelectedSuperintendente] =
    useState<Option | null>(null);
  const [selectedEquipe, setSelectedEquipe] = useState<Option | null>(null);
  const [selectedCorretor, setSelectedCorretor] = useState<Option | null>(null);
  const [checkCompartilharProposta, setCheckCompartilharProposta] =
    useState(false);
  const [selectedTipoFiltroData, setSelectedTipoFiltroData] =
    useState<Option | null>(null);
  const [dataInicio, setDataInicio] = useState<Date | null>(null);
  const [dataFim, setDataFim] = useState<Date | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterAction, setFilterAction] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [etapasQuantidade, setEtapasQuantidade] = useState<
    Record<string, number>
  >({});
  const [etapasPaginaAtual, setEtapasPaginaAtual] = useState<
    Record<string, number>
  >({});

  const countAppliedFilters = useMemo(() => {
    let count = 0;
    if (selectedEtapa) count += 1;
    if (selectedSubetapa.length > 0) count += 1;
    if (selectedEmpreendimento.length > 0) count += 1;
    if (selectedBloco) count += 1;
    if (selectedUnidade) count += 1;
    if (selectedOrigens.length > 0) count += 1;
    if (selectedSuperintendente) count += 1;
    if (selectedEquipe) count += 1;
    if (selectedCorretor) count += 1;
    if (selectedTipoFiltroData) count += 1;
    if (checkCompartilharProposta) count += 1;
    return count;
  }, [
    selectedEtapa,
    selectedSubetapa,
    selectedEmpreendimento,
    selectedBloco,
    selectedUnidade,
    selectedOrigens,
    selectedSuperintendente,
    selectedEquipe,
    selectedCorretor,
    selectedTipoFiltroData,
    checkCompartilharProposta,
  ]);

  const handleQuantidadeLoaded = useCallback(
    (codigo: string, quantidade: number, pagina: number) => {
      setEtapasQuantidade((prev) => {
        if (prev[codigo] === quantidade) return prev;
        return { ...prev, [codigo]: quantidade };
      });
      setEtapasPaginaAtual((prev) => {
        if (prev[codigo] === pagina) return prev;
        return { ...prev, [codigo]: pagina };
      });
    },
    []
  );

  const { data: dataEtapaListar } = usePropostasListarEtapas({
    comercial: false,
  });

  const etapas = useMemo(
    () =>
      dataEtapaListar?.colunas?.map((etapa: any) => ({
        codigo: etapa.codigo,
        nome: obterNomeEtapaExibicao(etapa.nome, usuarioVivaz),
      })) || [],
    [dataEtapaListar, usuarioVivaz]
  );

  const exportMutation = useExportarKanban(false);

  const handleExport = (codigosSelecionados: string[]) => {
    const maiorPagina = Math.max(
      ...codigosSelecionados.map((c) => etapasPaginaAtual[c] || 1)
    );

    exportMutation.mutate(
      {
        ListaCodigo: codigosSelecionados,
        Comercial: false,
        tipoFiltroData: selectedTipoFiltroData
          ? Number(selectedTipoFiltroData.value)
          : undefined,
        dataInicio: selectedTipoFiltroData ? toApiDate(dataInicio) : undefined,
        dataFim: selectedTipoFiltroData ? toApiDate(dataFim) : undefined,
        Etapa: selectedEtapa?.value || "",
        SubEtapa: selectedSubetapa.map((s) => s.value),
        IdEmpreendimento: selectedEmpreendimento.map((e) => e.value),
        IdBloco: selectedBloco?.value || undefined,
        IdUnidade: selectedUnidade?.value || undefined,
        IdsOrigens: selectedOrigens.map((origem) => origem.value),
        IdSuperintendente365: selectedSuperintendente?.value || undefined,
        IdGerente365: selectedEquipe?.value || undefined,
        IdCorretor365: selectedCorretor?.value || undefined,
        Compartilhadas: checkCompartilharProposta || undefined,
        PalavraChave: searchValue || undefined,
        PaginaAtual: maiorPagina,
        TotalItensRetorno: 3,
      },
      {
        onSettled: () => {
          setShowExportModal(false);
        },
      }
    );
  };

  const { data: dataEtapasFiltro } = usePropostasFiltrosEtapas({
    comercial: false,
  });

  const {
    data: dataSubEtapasFiltro,
    refetch: refetchSubEtapasFiltro,
    isFetching: isFetchingSubEtapasFiltro,
  } = usePropostasFiltrosSubEtapas({
    codigoEtapa: selectedEtapa?.value,
    comercial: false,
  });

  const handleSearch = () => {
    setFilterAction(true);
  };

  const handleOpenFilters = () => {
    setShowFilters(true);
  };

  const handleCloseFilters = () => {
    setShowFilters(false);
  };

  const handleEtapaChange = async (newValue: Option | null) => {
    await setSelectedEtapa(newValue);
    setSelectedSubetapa([]);
    refetchSubEtapasFiltro();
  };

  const handleSubetapaChange = (
    _event: React.SyntheticEvent<Element, Event>,
    newValues: Option[] | null
  ) => {
    if (newValues) {
      setSelectedSubetapa(newValues);
    }
  };

  const handleEmpreendimentoChange = (
    _event: React.SyntheticEvent<Element, Event>,
    newValues: Option[] | null
  ) => {
    if (newValues) {
      setSelectedEmpreendimento(newValues);
    } else {
      setSelectedEmpreendimento([]);
    }
    setSelectedBloco(null);
    setSelectedUnidade(null);
  };

  const handleBlocoChange = (newValue: Option | null) => {
    setSelectedBloco(newValue);
    setSelectedUnidade(null);
  };

  const handleUnidadeChange = (newValue: Option | null) => {
    setSelectedUnidade(newValue);
  };

  const handleOrigensChange = (
    _event: React.SyntheticEvent<Element, Event>,
    newValues: Option[] | null
  ) => {
    setSelectedOrigens(newValues || []);
  };

  const handleSuperintendenteChange = (newValue: Option | null) => {
    setSelectedSuperintendente(newValue);
    setSelectedEquipe(null);
    setSelectedCorretor(null);
  };

  const handleEquipeChange = (newValue: Option | null) => {
    setSelectedEquipe(newValue);
    setSelectedCorretor(null);
  };

  const handleCorretorChange = (newValue: Option | null) => {
    setSelectedCorretor(newValue);
  };

  const handleTipoFiltroDataChange = (newValue: Option | null) => {
    setSelectedTipoFiltroData(newValue);
    if (!newValue) {
      setDataInicio(null);
      setDataFim(null);
    }
  };

  const handleDataInicioChange = (newDate: Date | null) => {
    setDataInicio(newDate);
    if (newDate && dataFim && newDate > dataFim) {
      setDataFim(null);
    }
  };

  const handleDataFimChange = (newDate: Date | null) => {
    setDataFim(newDate);
    if (newDate && dataInicio && newDate < dataInicio) {
      setDataInicio(null);
    }
  };

  const handleApplyFilters = () => {
    setIsFilterApplied(countAppliedFilters > 0);
    setFilterAction(true);
    handleCloseFilters();
  };

  const handleClearFilters = () => {
    setSelectedEtapa(null);
    setSelectedSubetapa([]);
    setSelectedEmpreendimento([]);
    setSelectedBloco(null);
    setSelectedUnidade(null);
    setSelectedOrigens([]);
    setSelectedSuperintendente(null);
    setSelectedEquipe(null);
    setSelectedCorretor(null);
    setSelectedTipoFiltroData(null);
    setDataInicio(null);
    setDataFim(null);
    setIsFilterApplied(false);
    setFilterAction(true);
    setCheckCompartilharProposta(false);
    handleCloseFilters();
  };

  const handleClearAllFilters = () => {
    setSelectedEtapa(null);
    setSelectedSubetapa([]);
    setSearchValue("");
    setSelectedEmpreendimento([]);
    setSelectedBloco(null);
    setSelectedUnidade(null);
    setSelectedOrigens([]);
    setSelectedSuperintendente(null);
    setSelectedEquipe(null);
    setSelectedCorretor(null);
    setSelectedTipoFiltroData(null);
    setDataInicio(null);
    setDataFim(null);
    setIsFilterApplied(false);
    setFilterAction(true);
    setCheckCompartilharProposta(false);
    setShowFilters(false);
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: "/funil-de-propostas", name: "Funil de propostas" },
        ]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <S.Content>
        <S.Title>Funil de propostas</S.Title>
        <S.Description>Confira o funil de propostas atualizado.</S.Description>
        <S.Container>
          <S.Header>
            <Tooltip title="Exportar para Excel" placement="top" arrow>
              <S.ButtonExport
                onClick={() => setShowExportModal(true)}
                disabled={etapas.length === 0}
              >
                <IconsSVG.ExportarExcelIcon />
              </S.ButtonExport>
            </Tooltip>
            <InputGrid
              style={{ width: "500px" }}
              variant="outlined"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              handleBtnSearch={handleSearch}
            />
            <Badge
              badgeContent={isFilterApplied ? countAppliedFilters : 0}
              color="error"
            >
              <S.ButtonFilter type="button" onClick={handleOpenFilters}>
                <MdFilterList size={20} />
                Filtrar
              </S.ButtonFilter>
            </Badge>
            <S.ButtonClearFilter type="button" onClick={handleClearAllFilters}>
              <MdOutlineFilterListOff size={20} />
            </S.ButtonClearFilter>
          </S.Header>
          <S.SpaceY space={16} />
          <S.Body>
            {dataEtapaListar?.colunas?.map((etapa: any) => (
              <EtapaCard
                key={etapa.codigo}
                selectedEtapa={selectedEtapa}
                selectedSubetapa={selectedSubetapa}
                codigoEtapa={etapa.codigo}
                nomeEtapa={etapa.nome}
                searchValue={searchValue}
                filterAction={filterAction}
                setFilterAction={setFilterAction}
                selectedEmpreendimento={selectedEmpreendimento}
                selectedBloco={selectedBloco}
                selectedUnidade={selectedUnidade}
                selectedOrigens={selectedOrigens}
                selectedSuperintendente={selectedSuperintendente}
                selectedEquipe={selectedEquipe}
                selectedCorretor={selectedCorretor}
                selectedTipoFiltroData={selectedTipoFiltroData}
                dataInicio={dataInicio}
                dataFim={dataFim}
                checkCompartilharProposta={checkCompartilharProposta}
                onQuantidadeLoaded={handleQuantidadeLoaded}
              />
            ))}
          </S.Body>
        </S.Container>
      </S.Content>

      <SwipeableDrawer
        open={showFilters}
        anchor="right"
        onClose={handleCloseFilters}
        onOpen={handleOpenFilters}
      >
        <Filtro
          isOpen={showFilters}
          selectedEtapa={selectedEtapa}
          handleEtapaChange={handleEtapaChange}
          selectedSubetapa={selectedSubetapa}
          handleSubetapaChange={handleSubetapaChange}
          selectedEmpreendimento={selectedEmpreendimento}
          handleEmpreendimentoChange={handleEmpreendimentoChange}
          selectedBloco={selectedBloco}
          handleBlocoChange={handleBlocoChange}
          selectedUnidade={selectedUnidade}
          handleUnidadeChange={handleUnidadeChange}
          selectedOrigens={selectedOrigens}
          handleOrigensChange={handleOrigensChange}
          selectedSuperintendente={selectedSuperintendente}
          handleSuperintendenteChange={handleSuperintendenteChange}
          selectedEquipe={selectedEquipe}
          handleEquipeChange={handleEquipeChange}
          selectedCorretor={selectedCorretor}
          handleCorretorChange={handleCorretorChange}
          selectedTipoFiltroData={selectedTipoFiltroData}
          handleTipoFiltroDataChange={handleTipoFiltroDataChange}
          tipoFiltroDataOptions={tipoFiltroDataOptions}
          dataInicio={dataInicio}
          dataFim={dataFim}
          handleDataInicioChange={handleDataInicioChange}
          handleDataFimChange={handleDataFimChange}
          handleClearFilters={handleClearFilters}
          handleApplyFilters={handleApplyFilters}
          dataEtapasFiltro={dataEtapasFiltro}
          dataSubEtapasFiltro={dataSubEtapasFiltro}
          isFetchingSubEtapasFiltro={isFetchingSubEtapasFiltro}
          checkCompartilharProposta={checkCompartilharProposta}
          setCheckCompartilharProposta={setCheckCompartilharProposta}
        />
      </SwipeableDrawer>

      <ModalExportarKanban
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        onExport={handleExport}
        etapas={etapas}
        etapasQuantidade={etapasQuantidade}
        titulo="Exportar Funil de Propostas"
        isExporting={exportMutation.isLoading}
      />
    </>
  );
};

const SwipeableDrawer = styled(Swipeable)`
  .MuiDrawer-paperAnchorRight {
    width: 392px;
    border-radius: 8px 0px 0px 8px;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #2d5bff;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #2d5bff;
    }
    scrollbar-width: thin;
    scrollbar-color: #2d5bff transparent;
  }
`;

export default FunilPropostas;
